import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import PageTitle from "../../../commons/components/PageTitle";
import Modal from "../../../commons/components/Modal";
import { ROUTES } from "../../../commons/constants/routes/routes";

class NoticeDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: null,
      noticeId: null,
      isDeleteConfirmShow: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    const noticeId = window.location.pathname.split("/").pop();
    this.setState({ noticeId });
    this.getItem(noticeId);
  }

  async getItem(id) {
    try {
      const res = await axios.get(`/cst/api/notice/${id}`);
      this.setState({ item: res.data });
    } catch (e) {
      console.log(e);
    }
  }

  async handleDelete() {
    const { noticeId } = this.state;
    try {
      await axios.delete(`/adm/api/notice/${noticeId}`);
      this.props.history.push(ROUTES.NOTICE.MAIN);
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const { item, noticeId, isDeleteConfirmShow } = this.state;
    if (!item) return null;

    return (
      <>
        <PageTitle title="공지사항" location="공지 상세" />
        <FormWrapper>
          <FormContainer>
            <FormBox>
              <FormHead>제목</FormHead>
              <FormBody><ValueText>{item.title}</ValueText></FormBody>
            </FormBox>
            <FormBox>
              <FormHead>등록일</FormHead>
              <FormBody><ValueText>{item.createDt}</ValueText></FormBody>
            </FormBox>
            <FormBox>
              <FormHead>수정일</FormHead>
              <FormBody><ValueText>{item.updateDt}</ValueText></FormBody>
            </FormBox>
            <FormBox className="content-box">
              <FormHead>내용</FormHead>
              <FormBody>
                <ContentArea>{item.content}</ContentArea>
              </FormBody>
            </FormBox>
          </FormContainer>

          <ActionRow>
            <button
              type="button"
              className="delete-btn"
              onClick={() => this.setState({ isDeleteConfirmShow: true })}
            >
              삭제
            </button>
            <BtnGroup>
              <button
                type="button"
                onClick={() => this.props.history.push(ROUTES.NOTICE.MAIN)}
              >
                목록
              </button>
              <button
                type="button"
                className="primary"
                onClick={() => this.props.history.push(ROUTES.NOTICE.EDIT(noticeId))}
              >
                수정
              </button>
            </BtnGroup>
          </ActionRow>
        </FormWrapper>

        {isDeleteConfirmShow && (
          <Modal
            icon={true}
            title="삭제 확인"
            text="공지사항을 삭제하시겠습니까?"
            btnGroup={true}
            closeModal={() => this.setState({ isDeleteConfirmShow: false })}
            confirmModal={this.handleDelete}
          />
        )}
      </>
    );
  }
}

const FormWrapper = styled.div`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
  display: flex;
  align-items: flex-start;
  &.content-box {
    align-items: flex-start;
  }
`;
const FormHead = styled.p`
  width: 140px;
  flex-shrink: 0;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
`;
const FormBody = styled.div`
  flex: 1;
`;
const ValueText = styled.span`
  font-size: 15px;
  color: #191919;
`;
const ContentArea = styled.pre`
  font-size: 15px;
  color: #191919;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
  font-family: inherit;
  line-height: 1.6;
`;
const ActionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1176px;
  margin: 0 auto;
  .delete-btn {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    color: #ff5353;
    background-color: transparent;
    border: 1px solid #ff5353;
    &:hover {
      background-color: #fff0f0;
    }
  }
`;
const BtnGroup = styled.div`
  display: flex;
  gap: 12px;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &.primary {
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
    }
  }
`;

export default withRouter(NoticeDetail);
